import { FC } from 'react';
import { Table } from '../../../../../../../../../features/table/table';
import { useLang } from '../../../../../../../../../hooks/use-lang';
import { ChartInvalidData } from '../../../use-dashboard-charts';
import s from './dasboard-charts-widget-tasks-duration.module.css';
import { Input } from '../../../../../../../../../components/input/input';

export const DashboardChartsWidgetTasksDuration: FC<Partial<ChartInvalidData>> = ({
  onChangeMaxTime,
  ignoredTasks,
  maxTime,
}) => {
  const { t, getLocale } = useLang();

  return (
    <div className={s.feature}>
      <Input
        value={maxTime}
        onChange={(e) => onChangeMaxTime?.(Number(e.currentTarget.value))}
        type="number"
        placeholder={t('Факт не более')}
        size="sm"
      />
      <Table
        frontPagination
        cols={{
          type: { label: t('Задача') },
          employee: { label: t('Сотрудник') },
          delta: { label: t('Отклонение') },
        }}
        rows={ignoredTasks?.map((item) => {
          const { name, overtime, staff } = item;
          const title = getLocale(name);
          const employee = getLocale(staff);

          return {
            type: title,
            employee,
            delta: overtime,
          };
        })}
      />
    </div>
  );
};
